import React, { useEffect, useState } from 'react';
import styles from '../styles/Profile.module.css';
import Histogram from './Hist'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactSwitch from 'react-switch';

const SummaryOverview = () => {
    
    const [total, setTotal] = useState();
    const [data, setData] = useState();
    const [component_id, setComponentId] = useState(-1); 
    const [component_name, setComponentName] = useState(-1); 
    const [info, setInfo] = useState({});
    const [list, setList] = useState([]);
    const [allowNegative, setAllowNegative] = useState(true);
    const [batch, setBatch] = useState([]);
    const [batch_id, setBatchId] = useState();
    const [batchName, setBatchName] = useState();

    //store batch id and component id locally for workerscores page
    localStorage.setItem('batch_id', batch_id);
    localStorage.setItem('component_id', component_id);
    localStorage.setItem('batch', batchName);
    localStorage.setItem('component_name', component_name);


    //read the topmenu to get the selected batch
    const GetSelectedBatchName = () => {
      const selectedBatchElement = document.getElementById("SelectedBatch");
      if (selectedBatchElement) {
        return selectedBatchElement.innerHTML.trim();
      }
      return null;
    };

    //get all the batches 
    useEffect(() => {
      fetch(`/get_batch`)
        .then((response) => response.json())
        .then((batch) => {
          setBatch(batch);
          console.log("Batch data:", batch);
        })

    },[]);

    //function to set the batch ID currently selected IMPORTANT FOR GETTING SPECIFIC BATCH INFORMATION
    useEffect(() => {
      var BatchName
      var BatchNumber
      BatchName = GetSelectedBatchName();
      if ( BatchName === '' )
      {
        BatchName = "Default"
        BatchNumber = 1
      }
      else {console.log("FALSE")
          console.log(BatchName)}
          
      console.log("Batch Name: ", BatchName)
      for (let i = 0; i < batch.length; i += 1) {
        if (BatchName === batch[i].title){
          BatchNumber = batch[i].id
        }
      }
      
      setBatchId(BatchNumber)
      setBatchName(BatchName)
      console.log("Batch Number: ", BatchNumber)
    }, [batch]);
   
   
    // get the total amount of participants for a component
    useEffect(() => {
        fetch(`/get_component_count/${component_id}/${batch_id}`)
          .then((response) => response.json())
          .then((data) => {setTotal(data[0]);})
      },[component_id, batch_id]);


    //initialize the component list on load
    useEffect(() => {
      fetch('/get_component_list')
        .then(response => response.json())
        .then((list) => {
          setList(list);
          console.log("List data:", list);
        })

    }, []); 
    //component 10 is word recall
    //get the accuracies for a selected component and batch
    useEffect(() => {
        fetch(`/get_component_stats/${component_id}/${batch_id}`)
          .then((response) => response.json())
          .then((data) => {
            console.log("Component data:", data);
            setData(data); 
        })
    },[component_id, batch_id]);

      const handleDropdownChange = (event) => {
        const selectedInfo = JSON.parse(event.target.value);
        setInfo(selectedInfo); // Store selected component info
        setComponentId(selectedInfo.id); // Trigger fetching data based on new selection
        setComponentName(selectedInfo.name)
      };
      //function to allow negative numbers
      const filterData = (data) =>
        allowNegative ? data : data.filter((item) => (item.Accuracy || 0) >= 0);
        
      //function to calculate the mean
      const mean = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
          return 'N/A'; // Return 'N/A' if there's no data
        }
        if (data.length === 0) return 'N/A';
        const total = data.reduce((sum, item) => sum + (item.Accuracy || 0), 0); 
        const mean = total / data.length; 
        return mean.toFixed(2); 
      };

      //function to calculate the minimum accuracy
      const min = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
          return 'N/A'; // Return 'N/A' if there's no data
        }
        if (data.length === 0) return 'N/A';
        const min = Math.min(...data.map(item => item.Accuracy || 0))
        return min.toFixed(2); 
      };

      //function to calculate the maximum accuracy
      const max = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
          return 'N/A'; // Return 'N/A' if there's no data
        }
        if (data.length === 0) return 'N/A';
        const max = Math.max(...data.map(item => item.Accuracy || 0));
        return max.toFixed(2);
      };            

      return (
        <Container fluid> 
          <Row className="mt-4">
            <h4>Component Overview</h4>
          </Row>
          <Row className="mt-2">
            <h5>Select a task you would like to view the results for:</h5>
          </Row>
          <Row>
            <Col md={4}>
              <form onSubmit={(e) => e.preventDefault()}>
                <select className="form-select" onChange={handleDropdownChange} value={JSON.stringify(info) || ""}>
                  <option value="">Select a component</option>
                  {list.map(item => (
                    <option key={item.id} value={JSON.stringify({ id: item.id, name: item.title })}>{item.title}</option>
                  ))}
                </select>
              </form>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={6}>
              <div className={styles.info}>
                <b style={{ marginLeft: '10px'}}>Selected Batch Name: </b>
                {batchName}
                <br/>
                <b style={{ marginLeft: '10px'}}>Batch ID: </b>
                {batch_id}
                <br/><br/>
                <b style={{ marginLeft: '10px'}}>Total individuals who completed the task: </b>
                {total ? total.Count : 'N/A'}
                <br/><br/>
                <b style={{ marginLeft: '10px'}}>Mean Accuracy: </b>
                {Array.isArray(data) && data.length > 0 ? mean(filterData(data)) : 'N/A'}
                <br/>
                <b style={{ marginLeft: '10px'}}>Minimum Accuracy: </b>
                {Array.isArray(data) && data.length > 0 ? min(filterData(data)) : 'N/A'}
                <br/>
                <b style={{ marginLeft: '10px'}}>Maximum Accuracy: </b>
                {Array.isArray(data) && data.length > 0 ? max(filterData(data)) : 'N/A'}
                <br/>
                <br/>
                <b style={{ marginLeft: '10px'}}>Allow Negative Values</b>
                <br/>
                <ReactSwitch
                    checked={allowNegative}
                    onChange={() => setAllowNegative(!allowNegative)}
                    onColor="#00bfff"
                    offColor="#ccc"
                    height={20}
                    width={40}
                    handleDiameter={16} 
                  />
            </div>
              <Row>
              <div className="text-center">
                <a className="btn btn-lg" style={{background: '#e7e7e7'}} href="http://localhost:3000/clinic_app/worker_scores" target="_blank">Open Worker List</a>
               </div> 
              </Row>
            </Col>
            <Col md={5}>            
              <Row>
                  <Histogram histTitle={info.name} task_data={filterData(data)} 
                  min={Array.isArray(data) && data.length > 0 ? Math.min(...filterData(data).map(item => item.Accuracy || 0)) : '0'}
                  max={Array.isArray(data) && data.length > 0 ? Math.max(...filterData(data).map(item => item.Accuracy || 0)) : '1'}  />
              </Row>
            </Col>
          </Row>
        </Container>
      );
    };
export default SummaryOverview;

